import { initGlobalState } from 'qiankun';
import { reactive } from 'vue';
// 父应用的初始state
const initialState = reactive({
    loading: false,
    userInfo: {
        name: '',
        account: '',
        avatar: '',
    },
    userAllRoute: [],
    token: '',
    language: 'zh',
});
const actions = initGlobalState(initialState);
actions.onGlobalStateChange((newState, prev) => {
    // state: 变更后的状态; prev 变更前的状态
    for (const key in newState) {
        if (key in initialState) {
            initialState[key] = newState[key];
        }
    }
});
// 定义一个获取state的方法下发到子应用
actions.getGlobalState = (key) => {
    // 有key，表示取globalState下的某个子级对象
    // 无key，表示取全部
    return key ? initialState[key] : initialState;
};
export default actions;
